import React from "react";

import FullScreenDropdown from "../Common/FullScreenDropdown";
import NotificationDropdown from "../Common/NotificationDropdown";
import ProfileDropdown from "../Common/ProfileDropdown";
import LayoutModeDropdown from "Common/LayoutModeDropdown";
import { Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

//import images
import logodark from "../assets/images/logo-dark.png";
import logolight from "../assets/images/logo-light.png";
import iconLogo from "../assets/images/icon-logo.png";
import tradesmenLogoDark from "../assets/images/tradesmen-logo-dark.png";
import tradesmenLogoLight from "../assets/images/tradesmens-white.png";
import Language from "Common/Language";
import GlobalSmartSearch from "./GlobalSmartSearch";
import { getHeaderPageMeta } from "./pageMeta";
// import Language from "Common/Language";

interface JwtPayload {
  userType: string;
}

const getStoredAuthToken = () => {
  const authUser = localStorage.getItem("authUser");

  if (!authUser) return null;

  try {
    return JSON.parse(authUser);
  } catch (error) {
    return authUser.replace(/^"|"$/g, "");
  }
};

const toogleMenuBtn = () => {
  var windowSize = document.documentElement.clientWidth;

  if (windowSize > 767)
    document.querySelector(".hamburger-icon")?.classList.toggle("open");

  //For collapse horizontal menu
  if (document.documentElement.getAttribute("data-layout") === "horizontal") {
    document.body.classList.contains("menu")
      ? document.body.classList.remove("menu")
      : document.body.classList.add("menu");
  }

  //For collapse vertical menu
  if (document.documentElement.getAttribute("data-layout") === "vertical") {
    if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove("vertical-sidebar-enable");
      document.documentElement.getAttribute("data-sidebar-size") === "sm"
        ? document.documentElement.setAttribute("data-sidebar-size", "")
        : document.documentElement.setAttribute("data-sidebar-size", "sm");
    } else if (windowSize > 1025) {
      document.body.classList.remove("vertical-sidebar-enable");
      document.documentElement.getAttribute("data-sidebar-size") === "lg"
        ? document.documentElement.setAttribute("data-sidebar-size", "sm")
        : document.documentElement.setAttribute("data-sidebar-size", "lg");
    } else if (windowSize <= 767) {
      document.body.classList.add("vertical-sidebar-enable");
      document.documentElement.setAttribute("data-sidebar-size", "lg");
    }
  }

  //Two column menu
  if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
    document.body.classList.contains("twocolumn-panel")
      ? document.body.classList.remove("twocolumn-panel")
      : document.body.classList.add("twocolumn-panel");
  }
};

const Header = () => {
  const location = useLocation();
  const token = getStoredAuthToken();
  let decoded: any = "";
  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  } else {
    console.error("Token is null");
  }
  const isRelibuildUser =
    decoded.userType === "homeowner" ||
    decoded.userType === "broker" ||
    decoded.userType === "real_estate_agent";
  const darkBrandLogo = isRelibuildUser ? logodark : tradesmenLogoDark;
  const lightBrandLogo = isRelibuildUser ? logolight : tradesmenLogoLight;
  const compactBrandLogo = isRelibuildUser ? darkBrandLogo : iconLogo;
  const pageMeta = getHeaderPageMeta(location.pathname, location.search, decoded.userType);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="layout-width">
          <div className="navbar-header modern-navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to={"/"} className="logo logo-dark modern-brand" aria-label="Go to dashboard">
                  <span className="logo-sm">
                    <img src={compactBrandLogo} alt="" className={`brand-mark-image ${isRelibuildUser ? "relibuild-mark" : "tradesmen-mark"}`} />
                  </span>
                  <span className="logo-lg">
                    <img src={darkBrandLogo} alt={isRelibuildUser ? "RELiBUILD" : "The Tradesmen's Collective"} className="brand-full-image" />
                  </span>
                </Link>

                <Link to={"/"} className="logo logo-light modern-brand" aria-label="Go to dashboard">
                  <span className="logo-sm">
                    <img src={compactBrandLogo} alt="" className={`brand-mark-image ${isRelibuildUser ? "relibuild-mark" : "tradesmen-mark"}`} />
                  </span>
                  <span className="logo-lg">
                    <img src={lightBrandLogo} alt={isRelibuildUser ? "RELiBUILD" : "The Tradesmen's Collective"} className="brand-full-image" />
                  </span>
                </Link>
              </div>

              <Button
                variant="link"
                size="sm"
                type="button"
                className="px-3 fs-lg header-item vertical-menu-btn topnav-hamburger shadow-none"
                id="topnav-hamburger-icon"
                onClick={toogleMenuBtn}
                aria-label="Toggle navigation menu"
                title="Toggle navigation"
              >
                <i className="bi bi-layout-sidebar-inset" aria-hidden="true" />
              </Button>

              <div className="modern-page-context" aria-label="Current page">
                <nav aria-label="Breadcrumb" className="modern-page-breadcrumb">
                  {pageMeta.parent && (
                    <>
                      {pageMeta.parentPath ? <Link to={pageMeta.parentPath}>{pageMeta.parent}</Link> : <span>{pageMeta.parent}</span>}
                      <i className="bi bi-chevron-right" aria-hidden="true" />
                    </>
                  )}
                  <span aria-current="page">{pageMeta.title}</span>
                </nav>
              </div>

              <GlobalSmartSearch userType={decoded.userType} />
            </div>

            <div className="d-flex align-items-center modern-topbar-actions">
              {/* Browse by Apps Dropdown */}

              {/* Language Dropdown */}
              <Language />

              {/* My Cart Dropdown */}

              {/* FullScreenDropdown */}
              <FullScreenDropdown />

              {/* Layout Mode Dropdown */}
              <LayoutModeDropdown />

              {/* NotificationDropdown */}
              <NotificationDropdown />

              {/* ProfileDropdown */}
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>

      <div
        id="removeNotificationModal"
        className="modal fade zoomIn"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="NotificationModalbtn-close"
              ></button>
            </div>
            <div className="modal-body p-md-5">
              <div className="text-center">
                <div className="text-danger">
                  <i className="bi bi-trash display-4"></i>
                </div>
                <div className="mt-4 fs-md">
                  <h4 className="mb-1">Are you sure ?</h4>
                  <p className="text-muted mx-4 mb-0">
                    Are you sure you want to remove this Notification ?
                  </p>
                </div>
              </div>
              <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button
                  type="button"
                  className="btn w-sm btn-light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn w-sm btn-danger"
                  id="delete-notification"
                >
                  Yes, Delete It!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Header;
